/**
 * Returns the corresponding date in EST
 *
 * @param {Date} today Date from where to calculate EST hour
 * @returns {Date} Date in EST
 */
function getESTDate(today) {
  today = Object.prototype.toString.call(today) === '[object Date]' ? today : new Date();
  const millisecondsInAMinute = 60 * 1000;

  const utcDate = new Date(today.getTime() + (today.getTimezoneOffset() * millisecondsInAMinute));

  const estTimezoneOffsetMinutes = -300;
  const estDate = new Date(utcDate.getTime() + (estTimezoneOffsetMinutes * millisecondsInAMinute));

  return estDate;
}

export default getESTDate;
